import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from "jquery";
const $ = jQuery;

export class ZIDXMortgageCalculator implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxMortgageCalculatorContainer";
    }
    render(){
        // console.log("mortgage calculator");
        // Initial calculation on page load
        let self=this;
        // Add event listeners to all input fields to recalculate on change
        $(".zidx_homeprice", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_percentdown", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_loantype", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_currentrate", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_hometax", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_homeinsurance", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        $(".zidx_homehoa", this.zidx.peakidxShadowRoot).on('change', function(){self.calculateMonthlyPayment();});
        this.calculateMonthlyPayment();

    }

    calculateMonthlyPayment() {
        var price=parseFloat($(".zidx_homeprice", this.zidx.peakidxShadowRoot).val() as string);
        var down=parseFloat($(".zidx_percentdown", this.zidx.peakidxShadowRoot).val() as string)/100;
        let loanTypeSelect=$(".zidx_loantype", this.zidx.peakidxShadowRoot)[0] as HTMLSelectElement;
        var term=parseFloat(loanTypeSelect.options[loanTypeSelect.selectedIndex].value);
        var rate=parseFloat($(".zidx_currentrate", this.zidx.peakidxShadowRoot).val() as string)/100;
        var taxes=parseFloat($(".zidx_hometax", this.zidx.peakidxShadowRoot).val() as string);
        var insurance=parseFloat($(".zidx_homeinsurance", this.zidx.peakidxShadowRoot).val() as string);
        var hoa=parseFloat($(".zidx_homehoa", this.zidx.peakidxShadowRoot).val() as string);

        if (isNaN(price) || isNaN(down) || isNaN(term) || isNaN(rate) || isNaN(taxes) || isNaN(insurance) || isNaN(hoa)) {
            $('.zidx_mortgagePaymentResults', this.zidx.peakidxShadowRoot).html("Please enter valid numbers in all fields.");
            return;
        }

        var principal = price - (price * down);
        var monthlyRate = rate / 12;
        var numPayments = term * 12;

        var monthlyMortgage = 0;
        if (monthlyRate > 0) {
            monthlyMortgage = principal * monthlyRate / (1 - Math.pow(1 + monthlyRate, -numPayments));
        } else {
            monthlyMortgage = principal / numPayments;
        }

        var monthlyTaxes = taxes / 12;
        var monthlyInsurance = insurance / 12;
        var monthlyHOA = hoa / 12;

        var totalMonthlyPayment = monthlyMortgage + monthlyTaxes + monthlyInsurance + monthlyHOA;

        let html =
            '<h4>Monthly Payment Estimate</h4>' +
            'Total Payment: $' + totalMonthlyPayment.toFixed(2) + '<br>' +
            'Mortgage: $' + monthlyMortgage.toFixed(2) + '<br>' +
            'Taxes: $' + monthlyTaxes.toFixed(2) + '<br>' +
            'Insurance: $' + monthlyInsurance.toFixed(2) + '<br>' +
            'HOA Dues: $' + monthlyHOA.toFixed(2);

        console.log("html", html);
        $('.zidx_mortgagePaymentResults', this.zidx.peakidxShadowRoot).html(html);
    }

}